"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _policies = require("./exchanges/policies");

var _policies2 = _interopRequireDefault(_policies);

var _policies3 = require("./refunds/policies");

var _policies4 = _interopRequireDefault(_policies3);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } } // @ts-check

var BusbudTerms = function BusbudTerms(phrases, locale) {
  _classCallCheck(this, BusbudTerms);

  this.exchange_policies = new _policies2.default({ phrases: phrases, locale: locale });
  this.refund_policies = new _policies4.default({ phrases: phrases, locale: locale });
};

exports.default = BusbudTerms;
module.exports = exports.default;
//# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbIi4uLy4uL3NyYy92Mi9pbmRleC5qcyJdLCJuYW1lcyI6WyJCdXNidWRUZXJtcyIsInBocmFzZXMiLCJsb2NhbGUiLCJleGNoYW5nZV9wb2xpY2llcyIsIkV4Y2hhbmdlUG9saWNpZXMiLCJyZWZ1bmRfcG9saWNpZXMiLCJSZWZ1bmRQb2xpY2llcyJdLCJtYXBwaW5ncyI6Ijs7Ozs7O0FBRUE7Ozs7QUFDQTs7Ozs7OzBKQUhBOztJQUtxQkEsVyxHQUNuQixxQkFBWUMsT0FBWixFQUFxQkMsTUFBckIsRUFBNkI7QUFBQTs7QUFDM0IsT0FBS0MsaUJBQUwsR0FBeUIsSUFBSUMsa0JBQUosQ0FBcUIsRUFBRUgsZ0JBQUYsRUFBV0MsY0FBWCxFQUFyQixDQUF6QjtBQUNBLE9BQUtHLGVBQUwsR0FBdUIsSUFBSUMsa0JBQUosQ0FBbUIsRUFBRUwsZ0JBQUYsRUFBV0MsY0FBWCxFQUFuQixDQUF2QjtBQUNELEM7O2tCQUprQkYsVyIsImZpbGUiOiJpbmRleC5qcyIsInNvdXJjZXNDb250ZW50IjpbIi8vIEB0cy1jaGVja1xuXG5pbXBvcnQgRXhjaGFuZ2VQb2xpY2llcyBmcm9tIFwiLi9leGNoYW5nZXMvcG9saWNpZXNcIjtcbmltcG9ydCBSZWZ1bmRQb2xpY2llcyBmcm9tIFwiLi9yZWZ1bmRzL3BvbGljaWVzXCI7XG5cbmV4cG9ydCBkZWZhdWx0IGNsYXNzIEJ1c2J1ZFRlcm1zIHtcbiAgY29uc3RydWN0b3IocGhyYXNlcywgbG9jYWxlKSB7XG4gICAgdGhpcy5leGNoYW5nZV9wb2xpY2llcyA9IG5ldyBFeGNoYW5nZVBvbGljaWVzKHsgcGhyYXNlcywgbG9jYWxlIH0pO1xuICAgIHRoaXMucmVmdW5kX3BvbGljaWVzID0gbmV3IFJlZnVuZFBvbGljaWVzKHsgcGhyYXNlcywgbG9jYWxlIH0pO1xuICB9XG59XG4iXX0=